import type { AssetType } from './types';
import { AssetDefinitions } from './types';

const BASE_ROUTE = '/shipium-admin/configure';
const CARD_WORKFLOW_BASE_ROUTE = '/configure/configuration-v2';

export const buildAssetSummaryRoute = (type?: AssetType): string => {
  return type ? BASE_ROUTE + `/${type}` : BASE_ROUTE;
};

export const buildAssetDetailRoute = (type: AssetType, id: string): string => {
  return `${BASE_ROUTE}/${type}/${id}`;
};

export const buildAssetAddRoute = (type: AssetType): string => {
  return `${BASE_ROUTE}/${type}/add`;
};

export const buildAssetEditRoute = (type: AssetType, id: string, useCard = true): string => {
  if (useCard) {
    // Hopefully temporary until editing can fully be done in the Configuration Asset Pages
    switch (type) {
      case AssetDefinitions.Contacts.key: {
        return `/shipium-admin/configure/${type}/${id}/edit`;
      }
      case AssetDefinitions.Origins.key: {
        return `/shipium-admin/configure/${type}/${id}/edit`;
      }
      case AssetDefinitions.Addresses.key: {
        return `/shipium-admin/configure/${AssetDefinitions.Addresses.key}/${id}/edit`;
      }
      case AssetDefinitions.AddressBook.key: {
        return `/shipium-admin/configure/${AssetDefinitions.AddressBook.key}/${id}/edit`;
      }
      case AssetDefinitions.Schedules.key: {
        return `${CARD_WORKFLOW_BASE_ROUTE}/schedules/editScheduleWorkflow-${id}`;
      }
      case AssetDefinitions.ReturnSettings.key: {
        return `${CARD_WORKFLOW_BASE_ROUTE}/returnsSettings/editReturnsSetting-${id}`;
      }
      case AssetDefinitions.CarrierAccounts.key: {
        return `/shipium-admin/configure/${type}/${id}/edit`;
      }
      case AssetDefinitions.CarrierSettings.key: {
        return `/shipium-admin/configure/${type}/${id}/edit`;
      }
      case AssetDefinitions.CarrierRates.key: {
        return `/shipium-admin/configure/${type}/${id}/edit`;
      }
      case AssetDefinitions.CarrierRateSets.key: {
        return `/shipium-admin/configure/${type}/${id}/edit`;
      }
      case AssetDefinitions.Contracts.key: {
        return `/shipium-admin/configure/${type}/${id}/edit`;
      }
      case AssetDefinitions.LabelProperties.key: {
        return `${CARD_WORKFLOW_BASE_ROUTE}/labelProperties/editLabelPropertiesWorkflow-${id}`;
      }
      case AssetDefinitions.LabelAugmentations.key: {
        return `/shipium-admin/configure/${type}/${id}/edit`;
      }
      case AssetDefinitions.LabelAugmentationRules.key: {
        return `/shipium-admin/configure/${type}/${id}/edit`;
      }
      case AssetDefinitions.FulfillmentContexts.key: {
        return `${CARD_WORKFLOW_BASE_ROUTE}/carrierSelection/editFulfillmentContextWorkflow-${id}`;
      }
      case AssetDefinitions.Tenants.key: {
        return `/shipium-admin/configure/${type}/${id}/edit`;
      }
      case AssetDefinitions.CarrierSelectionOverrides.key: {
        // Don't see an edit workflow in Card Workflow. Using CA Edit page.
        return `${buildAssetDetailRoute(type, id)}/edit`;
      }
      case AssetDefinitions.ThirdPartyBillingAccounts.key: {
        return `${CARD_WORKFLOW_BASE_ROUTE}/thirdPartyBillingAccounts/editThirdPartyBillingAccount-${id}`;
      }
      case AssetDefinitions.ThirdPartyBillingAccountSets.key: {
        return `${CARD_WORKFLOW_BASE_ROUTE}/thirdPartyBillingAccountSets/editThirdPartyBillingAccountSet-${id}`;
      }
      case AssetDefinitions.Tags.key: {
        return `/shipium-admin/configure/${type}/${id}/edit`;
      }
      case AssetDefinitions.Packaging.key: {
        return `/shipium-admin/configure/${type}/${id}/edit`;
      }
      case AssetDefinitions.PackagingSets.key: {
        return `/shipium-admin/configure/${type}/${id}/edit`;
      }
      case AssetDefinitions.InjectionSites.key: {
        // Don't see an edit workflow in Card Workflow. Using CA Edit page.
        return `${buildAssetDetailRoute(type, id)}/edit`;
      }
      case AssetDefinitions.InjectionProfiles.key: {
        // Don't see an edit workflow in Card Workflow. Using CA Edit page.
        return `${buildAssetDetailRoute(type, id)}/edit`;
      }
      case AssetDefinitions.ReturnToAddressOverrides.key: {
        return `${CARD_WORKFLOW_BASE_ROUTE}/returnToAddressOverrides/editReturnToAddressOverridesWorkflow-${id}`;
      }
      default:
        return buildAssetSummaryRoute();
    }
  } else {
    return `${buildAssetDetailRoute(type, id)}/edit`;
  }
};

export const buildAssetImportRoute = (type: AssetType): string => {
  return `${BASE_ROUTE}/import?type=${type}`;
};

export const generateDeleteConfirmationPhrase = (): string => {
  const phrases = [
    'Enable scrappy decisions',
    'Demonstrate industry credibility',
    'Elevate the ecommerce experience',
    'Work with conviction and sincerity',
    'Fast is possible',
  ];
  return phrases[Math.floor(Math.random() * phrases.length)];
};
